<!-- Labels -->
<app-widget [label]="label.title" [open]="open" (opened)="handleOpened($event)">
  <!-- Header actions -->
  <span widget-actions>
    <button app-button buttonSize="small" [matMenuTriggerFor]="labelMenu">
      <fa-icon icon="ellipsis-v"></fa-icon>
    </button>
    
    <mat-menu #labelMenu="matMenu">
      <button mat-menu-item (click)="handleRemove()">Remove</button>
    </mat-menu>
  </span>
  
  <!-- Label form -->
  <form [formGroup]="form" autocomplete="off">
    <app-tabs>

      <!-- Content -->
      <app-tab label="Content">
        <div class="pt-2 pl-1">

          <app-form-field label="Title" class="pb-2">
            <input
              #title
              class="input"
              name="title"
              type="text"
              formControlName="title"
              maxlength="100"
              appBlurOnEscape>
            <app-character-counter [field]="title"></app-character-counter>
          </app-form-field>
          
          <app-form-field label="Description" class="pb-2">
            <textarea 
              #description
              class="input" 
              name="description" 
              formControlName="description" 
              maxlength="300" 
              rows="6" 
              appBlurOnEscape></textarea>
            <app-character-counter [field]="description"></app-character-counter>

          </app-form-field>
          
        </div>
      </app-tab>

      <!-- Styles -->
      <app-tab label="Style">
        <div class="pt-2 pl-1 text-12">

          <!-- Label Theme -->
          <app-form-field label="Label Theme">

            <select class="input" formControlName="theme">
              <option [value]="labelTheme.Annotation">Dark (Classic)</option>
              <!-- <option [value]="labelTheme.Classic">Classic</option> -->
              <option [value]="labelTheme.StudioNext">Light</option>
            </select>

          </app-form-field>

          <!-- Label Icon -->
          <app-form-field label="Label Pin" *ngIf="_theme === labelTheme.StudioNext">

            <select class="input" formControlName="pinType">
              <option [value]="labelPinType.Default">Circle</option>
              <option [value]="labelPinType.PlusMinus">Plus / Minus</option>
            </select>

          </app-form-field>

          <!-- Label Style -->
          <app-form-field label="Label Type" *ngIf="_theme === labelTheme.StudioNext">
            <select class="input mr-2" formControlName="hideWire" style="display: inline-block; width: 154px">
              <option [ngValue]="false">Leader Line</option>
              <option [ngValue]="true">Floating</option>
            </select>

            <app-button-group style="display: inline-block;">
              <button app-button buttonType="outline" matTooltip="Align Left" (click)="handleAlignClick('left')"><fa-icon icon="caret-left"></fa-icon></button>
              <button app-button buttonType="outline" matTooltip="Align Right" (click)="handleAlignClick('right')"><fa-icon icon="caret-right"></fa-icon></button>
            </app-button-group>
          </app-form-field>

          <!-- Label Glow -->
          <app-form-field *ngIf="_theme === labelTheme.StudioNext">
            <mat-checkbox formControlName="pinGlow">
              Make Pin Glow
            </mat-checkbox>
          </app-form-field>
        </div>
      </app-tab>

      <app-tab label="Actions">
        <div class="pt-2 pl-1 text-12">
           <!-- Label Layout -->
           <app-form-field label="On load">
              <app-list listType="flat">
                <app-list-item>
                  <mat-checkbox formControlName="hideTag" class="mr-4">
                    Hide tag
                  </mat-checkbox>
                </app-list-item>
  
                <app-list-item>
                  <mat-checkbox formControlName="collapseDescription">
                    Hide description
                  </mat-checkbox>
                </app-list-item>
              </app-list>
            </app-form-field>
  
            <!-- Click -->
            <app-form-field label="On click">
              <div *ngIf="label.hideTag"><mat-checkbox formControlName="expandTag">Show tag</mat-checkbox></div>
              <div *ngIf="label.collapseDescription"><mat-checkbox formControlName="showDescription">Show description</mat-checkbox></div>
              <div>
                <mat-checkbox formControlName="flyTo">Zoom label</mat-checkbox>
  
                <div class="pl-6 pt-2" *ngIf="_flyTo">
                  <!-- Camera -->
                  <app-form-field>
  
                    <select class="input" formControlName="flyToTarget">
                      <option [value]="labelFlyTo.Object">Zoom to label structure</option>
                      <option [value]="labelFlyTo.Position">Zoom to fixed position</option>
                    </select>
                    
                  </app-form-field>
        
                  <!-- Camera Position -->
                  <app-form-field *ngIf="_flyToTarget === labelFlyTo.Position">
                    <button app-button buttonType="outline" buttonSize="small" class="w-100" (click)="handleRecordPositionClick()">Mark Position</button>  
                  </app-form-field>
                </div>
              </div>
            </app-form-field>
        </div>
      </app-tab>
    </app-tabs>
  </form>
</app-widget>